import { createStripeCheckout, verifyStripePayment, getPaymentHistory } from '../api/client';

interface StripeResponse {
  success: boolean;
  checkoutUrl: string;
  sessionId: string;
}

export const paymentService = {
  /**
   * Creates a Stripe checkout session for donation payment
   * 
   * @param amount - The donation amount in USD
   * @param tierName - The name of the donation tier 
   * @returns Promise with checkout URL and session ID
   */
  createStripeCheckout: (amount: number, tierName: string) => createStripeCheckout({ amount, tierName }),
  
  /**
   * Verifies a Stripe payment after completion
   * 
   * @param sessionId - The Stripe session ID to verify
   * @returns Promise with payment verification result
   */
  verifyStripePayment: (sessionId: string) => verifyStripePayment({ sessionId }),
  
  /**
   * Gets payment history for the current user
   * 
   * @returns Promise with the user's payment history
   */
  getPaymentHistory: () => getPaymentHistory(),
};